import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Organization } from './models/organization.model';
import { SportCategory } from './models/sportCategory.model';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  public organizationTypeSubject: Subject<number> = new Subject();
  public organizationNameSubject: Subject<{}> = new Subject();

  constructor(private _http: HttpClient) {
  }

  setOrgName(orgNames) {
    this.organizationNameSubject.next(orgNames);
  }

  public getOrganization(orgId: string) {
    let paramas = new HttpParams();
    paramas = paramas.append('id', orgId);
    return this._http.get<Organization>(environment.serverUrl + 'organization/get', {
      params: paramas,
    }).pipe(
      map(responseData => {
        localStorage.setItem('orgId', responseData.organizationTypeId.toString());
        this.organizationTypeSubject.next(responseData.organizationTypeId);
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  splitArrayIntoChunksOfLen(arr: Array<any>, len: number) {
    const chunks = [], n = arr.length;
    let i = 0;
    while (i < n) {
      chunks.push(arr.slice(i, i += len));
    }
    return chunks;
  }

  deepSearchSportCategoriesById(id: number, sportCategories: SportCategory[]): SportCategory {
    if (!id) {
      return null;
    }
    for (let i = 0; i < sportCategories.length; i++) {
      const sportCategory = sportCategories[i];
      if (sportCategory.id === id) {
        return sportCategory;
      } else {
        if (sportCategory.children && sportCategory.children instanceof Array) {
          if (sportCategory.children.filter(c => c.id === id)[0]) {
            return sportCategory.children.filter(c => c.id === id)[0];
          }
        }
      }
    }
  }
}
